import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import styled from 'styled-components';
// @ts-ignore
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import Input, {
    nameDecorator,
    phoneDecorator,
    // @ts-ignore
} from '@ertelecom/ui-react/components/inputSimple';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';

export const Button = styled(StyledButton)`
  max-width: 200px;
  @media (max-width: 400px){
     max-width: unset;
  }
`;

export const NameInput = nameDecorator(Input);

export const PhoneInput = styled(phoneDecorator(Input))`
  width: 87%;
  @media (max-width: 400px){ 
    width: 100%; 
  }
`;

export const BreakHack = styled.div`
  @media (min-width: 896px) {
    margin-left: 5px;
  }
  
  white-space: nowrap;
  display: inline;
`;

export const ButtonLookLikeHref = styled.div`
  display: inline;
  color: ${COLORS.blue};
  cursor: pointer;
  margin-left: 5px;
`;

export const Popup = styled(DefaultPopup)`
  padding: 40px;
  display: flex;
  @media (max-width: 400px){
    padding: 26px;
  }
  @media (min-width: 760px){
    width: 700px !important;
  }
  @media (min-width: 900px){
    width: 800px !important;
  }
  @media (min-width: 1300px){
    width: 960px !important;
  }
  flex-direction: column;
  > * {
    margin-bottom: 20px;
  }
  > *:last-child{
    margin-bottom: unset;
  }
`;

export const RequestButton = styled.div<{ isHighlight: boolean | undefined | null }>`
  padding: 12px;
  background: ${props => props.isHighlight ? COLORS.black : COLORS.outlineGrey};
  border-radius: 4px;
  color: ${props => props.isHighlight ? COLORS.white : COLORS.black};
  font-family: ${FONTS.regular};
  text-transform: lowercase;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
   display: flex;
   flex-direction: row;
   > * {
    margin-right: 5px;
    margin-top: 12px;
   }
`;

export const Title = styled.h1`
  font-family: ${FONTS.regular};
  margin-top: 0;
`;

export const BaseContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 570px;
  @media (min-width: 400px){
    > * {
      margin-right: 10px;
      margin-bottom: unset;
    }
    > *:last-child {
      margin-right: unset;
    }
  }
  @media (max-width: 400px){
    flex-direction: column;
    align-items: center;
    > * {
      width: 100%;
      margin-bottom: 10px;
    }
    > *:last-child {
      margin-bottom: unset;
    }
  }
`;

export const InputContainer = styled(BaseContainer)`
    min-height: 72px;
    align-items: flex-start;
`;

export const Text = styled.div`
  font-family: ${FONTS.regular};
  line-height: 20px;
`;

export const PersText = styled.div`
  display: block;
  width: auto;
  font-family: ${FONTS.light};
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0.5px;
  > a {
    display: inline;
    color: ${COLORS.black};
    text-decoration: underline;
  }
`;

export const Message = styled.div<{ isError: boolean }>`
  color: ${props => props.isError ? COLORS.red : COLORS.green};
  font-family: ${FONTS.medium};
`;
